import React from "react";
  
//Component ==========
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx"; 
import CardContent from '@material-ui/core/CardContent';

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Autocomplete from "components/Autocomplete/Select.jsx";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CardIcon from "components/Card/CardIcon" 
import CardHeader from "components/Card/CardHeader"

// import URL from "UrlServer"
// import { APIGet,APIPost } from "APIRequest"
// import * as Alert from "alertService"

//Question Component ==========    
import Button from "components/CustomButtons/Button.jsx"
import image from "assets/img/banner_2019.jpg"; 

import PlayArrowIcon from "@material-ui/icons/PlayArrow"

import withStyles from "@material-ui/core/styles/withStyles";

import wordingIntro from "configs/wordingIntro.jsx" 

// import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import sidebarStyle from "assets/jss/material-dashboard-pro-react/components/sidebarStyle.jsx";

const wording = {
  text_btn:{
    th:"เริ่มทำแบบสอบถาม",
    en:"Start the questionnaire",
  }
}
const styles = {
  ...sidebarStyle,  
}
class SubjectLabelPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {     
      headerLabel:this.props.headerLabel,
    }
  }   
  render() {
    const { classes,data} = this.props;
    return (
      <div>  
        <Card className="card-bg-90">
          {
            (this.state.headerLabel)?
            <CardHeader color="info" icon>
              <CardIcon color="danger" className="icon-question">
                <span className="title-question">{this.state.headerLabel}</span>
              </CardIcon> 
            </CardHeader>
            :""
          } 
          <CardContent>  
            <b>&emsp;&emsp;&emsp;&emsp;&emsp;{data}</b>
          </CardContent>
        </Card> 
        {/* <div > 
          <Paper className="card-intro-subject">
            <Typography variant="h6" component="h6">
              {data.subject} 
            </Typography> 
            {
              (data.descriptions)?  
              <Typography component="p">
                {data.descriptions}
              </Typography>   
              :""
            }
          </Paper>
        </div> */}
      </div>
    );
  }
} 
export default withStyles(styles)(SubjectLabelPage)